module.exports = __webpack_public_path__ + "img/typescript.9a0683e9.png";